{
  "pagination": {
    "showing": "Showing",
    "to": "to",
    "of": "of",
    "results": "results",
    "previous": "Previous",
    "next": "Next"
  },
  "copyRight": "2022 All rights reserved",
  "generic": {
    "back": "Back to"
  },
  "header": {
    "viewCompany": "View company",
    "viewProfile": "View profile",
    "signOut": "Sign out"
  },
  "buttons": {
    "Continue": "Continue",
    "Done": "Done!",
    "Delete": "Delete",
    "Cancel": "Cancel",
    "Add": "Add",
    "Update": "Update",
    "Save": "Save",
    "Saving": "Saving",
    "Previous": "Previous",
    "Add facility": "Add facility",
    "surveySave": "Save",
    "next": "Next",
    "EXPORT_DATA": "Export Data"
  },
  "errors": {
    "required": "{name} is a required field",
    "Attention": "Attention"
  },
  "months": {
    "1": "January",
    "2": "February",
    "3": "March",
    "4": "April",
    "5": "May",
    "6": "June",
    "7": "July",
    "8": "August",
    "9": "September",
    "10": "October",
    "11": "November",
    "12": "December"
  },
  "nav": {
    "Dashboard": "Dashboard",
    "Calculation": "Calculation",
    "Analysis": "Analysis",
    "Goals": "Goals",
    "Comparison": "Comparison",
    "Reports": "Reports",
    "viewProfile": "View profile,",
    "signOut": "Sign out",
    "Decarbonization": "Decarbonization",
    "DataHub": "Data Hub",
    "DataEntry": "Data Entry",
    "FormBuilder": "Form Builder",
    "DataExplorer": "Data Explorer",
    "SavedQueries": "Saved Queries",
    "DataReport": "Data Report"
  },
  "dataHub": {
    "title": "Data Hub",
    "subtitle": "Centralized data management and entry system",
    "dataEntry": "Data Entry",
    "dataEntryDesc": "Create and manage form submissions using dynamic input forms",
    "dataManagement": "Data Management",
    "dataIntegration": "Data Integration", 
    "comingSoon": "Coming soon...",
    "inputForms": "Input Forms",
    "inputFormsDesc": "Create and manage form submissions using dynamic input forms"
  },
  "login": {
    "welcome": "Welcome",
    "subText": "Enter your e-mail and the password we sent you",
    "username": "Email",
    "password": "Password",
    "login": "Login",
    "forgotPasswordHelpText": "Trouble Loggin in?",
    "contactUs": "Contact us",
    "inValidLogin": "Invalid username or password",
    "emailIsRequired": "Email is a required field",
    "inValidEmail": "Email must be a valid email",
    "passwordIsRequired": "Password is required field"
  },
  "forgotPassword": {
    "forgotPassword": "Forgot password",
    "backToLogin": "Back to login",
    "forgotPasswordExplanation": "Enter the email associated with the account and we will send you a link to change it.",
    "forgotSuccessTitle": "Password reset link was sent to your email.",
    "forgotAttention": "If you have not received the password renewal email:",
    "forgotWarning1": "Check your spam and other e-mail folders.",
    "forgotWarning2": "Check that the e-mail address you entered is correct.",
    "sendEmail": "Send Email",
    "changePassword": "Change password",
    "changePasswordExplanation": "Your password must be at least 8 characters and should contain letters and numbers.",
    "changeError": "Invalid activation code or token expired.",
    "changeSuccessMsg": "Your password has been updated.",
    "resetMyPassword": "Reset my password"
  },
  "placeHolder": {
    "threeCharacters": "Type at least 3 characters"
  },
  "welcome": {
    "thankYouText": "Thank you for taking the first steps to decarbonize your company!",
    "description": "We will start with some questions to customize the platform to your needs",
    "button": "Let’s start"
  },
  "personal": {
    "pageTitle": "Share with us the following information",
    "firstName": "Name(s)",
    "lastName": "Last name(s)",
    "title": "Position within the company",
    "createPassword": "Create a new login password",
    "newPassword": "New password",
    "confirmPassword": "Confirm new password",
    "noMatch": "Passwords must match",
    "userTitle": "Position"
  },
  "companySetting": {
    "pageTitle": "It’s a pleasure to meet you, {name}",
    "description": "Tell us about your company",
    "companyName": "Company name",
    "sector": "Sector",
    "subSector": "Sub sector",
    "helpText": "If you can't find yours, select \"Other\"",
    "sectors": "Sectors",
    "infoText": "A sector is a set of economic activities created according to the essence of the tasks or activities carried out by your company. Within a sector there are other ramifications called sub-sectors, created to specify in greater detail the activity that your company carries out.",
    "intensityUnit": "Production Unit"
  },
  "operationInfo": {
    "title": "In the next step we will enter into detail about your operations",
    "p1": "Carbon footprint is calculated within each facility you have, being a factory, distribution center, office, shop or any other type of facility.",
    "p2": "Now, you’ll help us define the types of facilities you use and some particular details about each one."
  },
  "facility": {
    "title": "What types of facilities do you have?",
    "description": "Select all that apply",
    "otherFacilityType": "Other facility type",
    "infoTitle": "Facilities",
    "infoText": "A facility is the location where your company carries out its activity. You could have one or more for different purposes. For example: BUILD GROUP is a company that develops construction materials and has 3 facilities, the first is a factory, the second is a store and the third is a laboratory.",
    "otherFacilityPlaceOlder": "Type of installation",
    "showAll": "Show all facilities",
    "showLess": "Show less facilities",
    "allFacilities": "All facilities",
    "detail": {
      "title": "Let’s go into detail",
      "description": "Share some detailes about each facility",
      "uploadButtonText": "Upload my own list",
      "header": {
        "facility": "Facility",
        "name": "Define a name",
        "nameToolTipDesc": "It will be the name with which we identify this facility throughout the entire platform. We recommend using the name used internally by the company.",
        "location": "Add a location",
        "locationToolTipDesc": "Add the location of the installation through Google Maps.",
        "tags": "Tags",
        "tagToolTipDesc": "Labels are very important, they will help us group installations and make filters later. If your company has, for example, \"Northeast and South factories\", be sure to add those labels that identify each one. We have pre-added some geotags, you can edit or remove them if you want."
      },
      "AddIntensity": "Add intensity",
      "intensity": {
        "title": "Add intensity",
        "updateTitle": "Update intensity",
        "year": "Year",
        "employee": "Number of employees",
        "income": "Annual income",
        "production": "Production",
        "errorMessage": "Enter at least one intensity type"
      },
      "form": {
        "name": "Name",
        "address": "Address",
        "search": "Search",
        "tags": "Tags",
        "addTag": "Add tag",
        "tagName": "Tag name",
        "countrySelected": "Country",
        "city": "City",
        "saveTag": "Save tag"
      },
      "confirmDeleteFacility": "{name} facility will be deleted, Click delete to confirm?",
      "unnamedDeleteFacility": "Unnamed facility will be deleted. Click delete to confirm",
      "facilityTypeError": "Please check the form. There should not be a facility type with the same name or the facility type name should not be empty.",
      "deleteFacility": "Delete facility",
      "facilityDetail": "Facility Detail",
      "deleteModalTitle": "Facility will be deleted, are you sure?",
      "deleteModalText": "After this operation, all records of the facility will be deleted",
      "deletedSuccessMessage": "Facility has been deleted",
      "LOCATION": "Location",
      "TAGS": "Tags"
    },
    "facilityCreated": "Facility successfully created ",
    "loading": "Loading facility types...",
    "saving": "Saving facility types",
    "success": {
      "customTypeRemoved": "Custom facility type removed successfully",
      "fileUploaded": "Facility file uploaded successfully",
      "saved": "Facility types saved successfully"
    },
    "warning": {
      "facilityLimitReached": "Facility limit reached. Cannot add more custom types"
    },
    "validation": {
      "typeNameRequired": "Facility type name is required",
      "typeNameMinLength": "Facility type name must be at least 3 characters",
      "typeNameMaxLength": "Facility type name cannot exceed 100 characters",
      "typeNameInvalidChars": "Facility type name cannot contain special characters: ? $ ' #",
      "typeNameDuplicate": "This facility type name already exists",
      "atLeastOneFacility": "At least one facility is required",
      "facilityLimitExceeded": "Total facilities cannot exceed {limit}"
    },
    "error": {
      "decreaseCount": "Error decreasing facility count",
      "invalidName": "Invalid facility name",
      "removeCustomType": "Error removing custom facility type",
      "validationFailed": "Please fix validation errors before submitting",
      "submit": "Error saving facility types",
      "loadFailed": "Failed to load facility types",
      "saveFailed": "Failed to save facility types",
      "duplicateNames": "Duplicate facility type names are not allowed"
    }
  },
  "emissionSetting": {
    "title": "What type of emissions do your {title} generate?",
    "selectAll": "Select all that apply",
    "modal": {
      "title": "Select emissions about {title}",
      "selected": "selected",
      "facilityTypeName": {
        "offices": "offices",
        "plants": "plants",
        "factories": "factories",
        "shops": "shops",
        "Distribution Center": "distribution centers",
        "Distribution": "distribution centers"
      }
    }
  },
  "finish": {
    "title": "We are done!",
    "description": "In just a second you’ll have access to the platform..."
  },
  "units": {
    "kg": "Kg",
    "tonne": "Tonne",
    "piece": "Piece",
    "m3": "m3",
    "m2": "m2",
    "percentage": "%",
    "meter": "Meter",
    "weight": "Weight",
    "km": "km"
  },
  "Facilities": "Facilities",
  "searchInputPlaceholder": "Search facilities or tags",
  "calculation": {
    "EMISSION_TYPE": "Emission Type",
    "searchEmission": "Search emission",
    "title": "Fill in your emissions information",
    "addEmissionButton": "Add emission",
    "addInfoButton": "Add info",
    "emission": "Emission",
    "calculation": "Calculation",
    "deleteAlert": "The record will be deleted Are you sure?",
    "fileSelected": "1 file selected | {count} files selected",
    "uploadFile": "Upload file",
    "quantityUsed": "Quantity Used",
    "numberOfAnimals": "Number of Animals",
    "temperature": "Average Temperature (°C)",
    "wetness": "Manure management",
    "eggs": "Kg of eggs produced",
    "area": "Area",
    "areaPlaceHolder": "Area (Hectare)",
    "nofPassenger": "Nof Passengers",
    "distance": "Distance",
    "card": {
      "emissionSourceManage": "Manage emission source",
      "completeCalculation": "Mark as done",
      "markExplanation": "If you have finished this emission's group calculation, you can select complete calculation. You can undo it at any time."
    },
    "carbonFootprintPeriod": {
      "ANNUAL": "ANNUAL",
      "MONTHLY": "MONTHLY",
      "CUSTOM": "CUSTOM"
    },
    "oneWay": "One way",
    "return": "Round Trip",
    "addEmission": {
      "title": "Add emission",
      "subTitle": "Select one or more"
    },
    "modal": {
      "title": "Consumption data",
      "subTitle": "Add your consumptions per period",
      "unitErrorDesc": "There was an unexpected error",
      "unitError": "No Emission Unit Error"
    },
    "periodType": "Period type",
    "consumption": "Consumption",
    "shortDescription": "Short description",
    "uploadEvidence": "Upload evidence",
    "month": "Month",
    "customDate": "Select start and close",
    "typeOfPeriod": "Type of period",
    "periodDate": "Period date",
    "delete": "Delete",
    "actions": "Actions",
    "edit": "Edit",
    "year": "Year",
    "Emission": "Emission",
    "viewFile": "View file",
    "deleteFile": "Delete file",
    "noData": "No data available",
    "departure": "Departure",
    "arrival": "Arrival",
    "distanceQuestion": "Do you know the distance information?",
    "from": "From",
    "to": "To",
    "manureManagementTitle": "Manure Management Explanation",
    "manureManagement": "Manure Management",
    "selectManureManagement": "Select",
    "manureManagementTooltip": "Manure Management Overview",
    "tooltip": {
      "title": "Detail",
      "departure": "Select or enter the starting location of your journey or activity.",
      "arrival": "Specify the destination or endpoint of your journey or activity.",
      "shortDescription": "Provide a brief summary of the trip or activity for reference.",
      "uploadEvidence": "Attach supporting documents, such as receipts or tickets, to verify your carbon footprint data.",
      "consumption": "Enter the amount of fuel, electricity, or other resources consumed during the journey or activity.",
      "carbonStory": "View your facility's carbon footprint analysis, including historical emissions data and sustainability insights.",
      "from": "Select or enter the starting location of your journey or activity.",
      "to": "Specify the destination or endpoint of your journey or activity.",
      "distanceQuestion": "If available, enter the travel distance manually or confirm if you want it to be calculated automatically."
    }
  },
  "collaborator": {
    "form": {
      "title": "Add collaborator",
      "firstName": "Name",
      "lastName": "Last name",
      "email": "Email",
      "position": "Position within the company",
      "role": "User role",
      "assigningFacility": "Assigning facility",
      "selectFacilities": "Select facilities",
      "button": "Send information"
    },
    "table": {
      "name": "Name",
      "email": "Email",
      "position": "Position within the company",
      "facility": "Facility",
      "actions": "Actions"
    }
  },
  "analysis": {
    "emissions": "Emissions",
    "allFacility": "All Facility",
    "searchFacilityOrTags": "Search for facility or tag",
    "analysis": "Analysis",
    "searchForTag": "Search for tag",
    "searchForFacility": "Search for facility",
    "scope": {
      "1": "Scope 1",
      "2": "Scope 2",
      "3": "Scope 3",
      "BIOGENIC": "Biogenic",
      "Biogenic Emissions": "Biogenic Emissions",
    },
    "EMISSION_FACTOR_TYPES": {
      "STANDARD": "Direct Emissions",
      "BIOGENIC": "Biogenic",
      "FLAG": "FLAG"
    },
    "FACILITY": "Facility",
    "GHG": "GHG Protocol Category",
    "SCOPE": "Scope",
    "EMISSION_GROUP": "Emission Group",
    "EMISSION_SOURCE": "Emission Source",
    "EMISSION_TYPE": "Emission Type",
    "all": "All",
    "total": "Total",
    "custom": "Custom",
    "Intensity": "Intensity",
    "customDatePlaceholder": "Select start and close",
    "EMPLOYEE": "Employee",
    "INCOME": "Income",
    "PRODUCTION": "Production",
    "exportAnalysis": "Export analysis",
    "company": "Company",
    "COUNTRY": "Country",
    "ALL_DATA_MSG": "You are viewing the top 20 records with the highest values in the chart. Please click the button below to view all data."
  },


  "dashboard": {
    "carbonFootprint": "Carbon footprint",
    "carbonFootprintToolTip": "In this area you can see a quick emission summary of your company",
    "carbonStory": "Carbon story",
    "goIntoDetail": "Go into detail",
    "Notifications": "Notifications",
    "seeAll": "See all",
    "Activity": "Activity"
  },
  "reports": {
    "reports": "Reports",
    "reportNumber": "Report {number}",
    "create": "Create report",
    "type":"Type",
    "name":"Name",
    "creator":"Creator",
    "period":"Period",
    "actions":"Actions",
    "createdAt":"Date Created",
    "tooltips": {
      "download": "Download",
      "edit": "Edit",
      "viewGraphs": "View Graphs",
      "hideGraphs": "Hide Graphs",
      "delete": "Delete"
    },
    "badges": {
      "draft": "Draft"
    },
    "loading": {
      "reportData": "Loading report data...",
      "downloadingReport": "Downloading report..."
    },
    "errors": {
      "failedToLoadReportData": "Failed to load report data",
      "failedToDownloadReport": "Failed to download report",
      "reportNotFound": "Report not found"
    },
    "messages": {
      "noDataAvailable": "No data available for this report"
    },
    "reportType": {
      "title": "Type of report",
      "subtitle": "Select the type of report you want to create",
      "internalReport": "Internal report",
      "ghgReport": "GHG",
      "selectPeriod": "Select type of period"
    },
    "configInternalReport" : {
      "title": "Internal report",
      "subtitle": "Add a section to your report",
      "chartTypePie": "Pie",
      "chartTypeBar": "Time",
      "addToReport": "Add to report",
      "annual": "Annual",
      "name": "Chart name",
      "description": "Chart description"
    },
    "internalReportReview": {
      "title": "Check your report",
      "subtitle": "Before saving, do one last review of your report",
      "companyInformation": "Company's information",
      "companyName": "Company name",
      "sector": "Sector",
      "askReportName": "Please input a name for your report",
      "setReportName": "Report name",
      "subSector": "Subsector",
      "saveReport": "Save report",
      "creatingReport":"Generating Report"
    },
    "entityName": "GHG Report",
    "entityFields": {
      "improvements":"Quality Assurance & Inventory Improvements",
      "contractual-provisions": "Contractual Provisions",
      "management-programs": "Management Programs",
      "generated-energy": "Generated Energy",
      "resold-energy": "Resold Energy",
      "base-year-recalc-policy": "Base Year Recalculation Policy",
      "emission-change-context": "Emission Change Context",
      "calc-methods-tools": "Calculation Methods and Tools",
      "sequestration": "Sequestration",
      "Company Name": "Company Name"
    },
    "ghg": {
      "steps": {
        "COMPANY_VERIFICATION_INFO": "Company & Verification Info",
        "REPORTING_SCOPE_BOUNDARIES": "Reporting Scope & Boundaries",
        "EMISSIONS_OVERVIEW": "Emissions Overview",
        "EMISSION_SOURCES_BREAKDOWN": "Emission Sources & Breakdown",
        "BASE_YEAR_TRENDS": "Base Year & Historical Trends",
        "METHODOLOGIES_ORGANIZATION": "Methodologies & Organizational Structure",
        "GHG_MANAGEMENT_REDUCTION": "GHG Management & Reduction",
        "OFFSETS_ADDITIONAL_DISCLOSURES": "Offsets & Additional Disclosures"
      },
      "actions": {
        "saveAndDownload": "Save & Download",
        "previewReport": "Preview Report",
        "saveDraft": "Save Draft"
      },
      "draftSavedMessage":"Your GHG report draft has been saved successfully.",
      "draftSavedHeader":"Draft Saved",
      "reportCompletionStatus": "Report Completion Status",
      "baseYearTrends": {
        "title": "Base Year & Historical Trends",
        "sectionCompletion": "Section completion",
        "baseYearInfo": "Base Year Information",
        "baseYearSelection": "Base Year Selection",
        "baseYearPlaceholder": "YYYY",
        "baseYearHelper": "Select the year that will serve as the baseline for comparison",
        "recalculationPolicy": {
          "title": "Base Year Emissions Recalculation Policy",
          "description": "Define when and how base year emissions will be recalculated",
          "placeholder": "Describe your policy for recalculating base year emissions (e.g., thresholds for recalculation, structural changes, methodology updates)...",
          "aiAssist": "AI Assist",
          "skipSection": "Skip this section",
          "sectionSkipped": "This section has been skipped"
        },
        "emissionsChanges": {
          "title": "Context for Emissions Changes",
          "description": "Explain significant changes in emissions compared to previous years",
          "placeholder": "Provide context for any significant emissions changes (e.g., business expansion, operational changes, improved data quality)...",
          "aiAssist": "AI Assist",
          "skipSection": "Skip this section",
          "sectionSkipped": "This section has been skipped"
        },
        "baseYearEmissions": {
          "title": "Base Year Emissions Data",
          "infoText": "Enter the emissions data for your selected base year. This will serve as the baseline for future comparisons.",
          "headers": {
            "baseYear": "Base Year",
            "total": "Total (tCO2e)",
            "co2": "CO2 (tCO2e)",
            "ch4": "CH4 (tCO2e)",
            "n2o": "N2O (tCO2e)",
            "hfcs": "HFCs (tCO2e)",
            "pfcs": "PFCs (tCO2e)",
            "sf6": "SF6 (tCO2e)"
          }
        },
        "historicalData": {
          "title": "Historical GHG Emissions Data",
          "noData": "No historical emissions data available",
          "noDataHelper": "Historical data will be populated from your previous reports",
          "headers": {
            "year": "Year"
          }
        },
        "intensityMetrics": {
          "title": "Intensity Metrics",
          "aiAssist": "AI Assist",
          "noteTitle": "Note:",
          "noteText": "Intensity metrics help normalize emissions data and can include metrics like emissions per revenue, per employee, per unit of production, etc.",
          "noData": "No intensity metrics available",
          "noDataHelper": "Intensity metrics will be calculated based on your operational data",
          "headers": {
            "intensityType": "Intensity Type",
            "value": "Value"
          }
        }
      },
      "companyVerificationInfo": {
        "title": "Company & Verification Info",
        "sectionCompletion": "Section completion",
        "companyInfo": {
          "title": "Company Information",
          "reportName": "Report Name",
          "reportNamePlaceholder": "Enter report name",
          "inventoryYear": "Inventory Year",
          "inventoryYearPlaceholder": "YYYY"
        },
        "verificationInfo": {
          "title": "Verification Information",
          "isVerifiedQuestion": "Is this report verified by a third party?",
          "verificationOptions": {
            "notVerified": "Not Verified",
            "verified": "Verified"
          },
          "verifierName": "Verifier Name",
          "verifierNamePlaceholder": "Enter verifier name",
          "verificationDate": "Date of Verification",
          "verifierEmail": "Verifier Email",
          "verifierEmailPlaceholder": "email{'@'}emample.com",
          "verifierPhone": "Verifier Phone",
          "verifierPhonePlaceholder": "+1 (555) 123-4567",
          "verifierAddress": "Verifier Address",
          "verifierAddressPlaceholder": "Enter verifier address"
        }
      },
      "emissionSourcesBreakdown": {
        "title": "Emission Sources & Breakdown",
        "sectionCompletion": "Section completion",
        "calculatedFromEmissionData": "Calculated from emission data",
        "calculatedFromFacilityData": "Calculated from facility data",
        "calculatedFromLocationData": "Calculated from location data",
        "scopes": {
          "scope1": "Scope 1",
          "scope2": "Scope 2",
          "scope3": "Scope 3",
          "scope1Title": "Scope 1: Direct Emissions",
          "scope2Title": "Scope 2: Indirect Emissions",
          "scope3Title": "Scope 3: Other Indirect Emissions"
        },
        "emissionSources": {
          "co2Emissions": "CO2 Emissions",
          "ch4Emissions": "CH4 Emissions",
          "n2oEmissions": "N2O Emissions",
          "hfcsEmissions": "HFCs Emissions",
          "pfcsEmissions": "PFCs Emissions",
          "sf6Emissions": "SF6 Emissions",
          "totalScope1": "Total Scope 1",
          "totalScope2": "Total Scope 2",
          "totalScope3": "Total Scope 3"
        },
        "tableHeaders": {
          "emissionSource": "Emission Source",
          "value": "Value (tCO2e)",
          "facilityName": "Facility Name",
          "country": "Country",
          "scope1": "Scope 1 (tCO2e)",
          "scope2": "Scope 2 (tCO2e)",
          "scope3": "Scope 3 (tCO2e)",
          "total": "Total (tCO2e)"
        },
        "tabs": {
          "emissionsByFacility": "Emissions by Facility",
          "emissionsByCountry": "Emissions by Country"
        },
        "noDataMessages": {
          "noScope1Data": "No Scope 1 emission data available",
          "noScope2Data": "No Scope 2 emission data available",
          "noScope3Data": "No Scope 3 emission data available",
          "noFacilityData": "No facility emission data available",
          "noCountryData": "No country emission data available"
        },
        "facilityNote": "Required for facilities with emissions >10,000 tCO2e per GHG Protocol guidelines.",
        "additionalDisclosures": {
          "title": "Additional Disclosures",
          "actionRequired": "Action Required",
          "generatedEnergy": {
            "title": "Generated Energy",
            "description": "Energy generation activities and associated emissions",
            "label": "Generated Energy Details",
            "placeholder": "Describe your energy generation activities, quantities (MWh), and associated emissions (tCO2e)",
            "aiAssist": "AI Assist",
            "skipSection": "Skip this section",
            "sectionSkipped": "This section has been skipped"
          },
          "resoldEnergy": {
            "title": "Resold Energy",
            "description": "Energy resale activities and associated emissions",
            "label": "Resold Energy Details",
            "placeholder": "Describe your energy resale activities, quantities (MWh), and associated emissions (tCO2e)",
            "aiAssist": "AI Assist",
            "skipSection": "Skip this section",
            "sectionSkipped": "This section has been skipped"
          },
          "noteTitle": "Note:",
          "noteText": "These sections are optional. You can skip them if your organization does not generate or resell energy, or provide details if applicable."
        }
      },
      "emissionsOverview": {
        "title": "Emissions Overview",
        "sectionCompletion": "Section completion",
        "scopeEmissionData": {
          "title": "Scope Emission Data",
          "description": "Total emissions by scope and individual greenhouse gases",
          "calculatedNote": "(Calculated from emission data)",
          "noDataMessage": "No emission data available yet. Complete the emission calculation steps to see data here."
        },
        "totalEmissionsSummary": {
          "title": "Total Emissions Summary",
          "scope1": "Scope 1",
          "scope2": "Scope 2",
          "scope3": "Scope 3",
          "totalEmissions": "Total Emissions:",
          "unit": "tCO2e"
        },
        "biogenicEmissions": {
          "title": "Biogenic CO2 Emissions",
          "description": "CO2 emissions from the combustion of biomass/biofuels",
          "reportedSeparately": "(Reported separately from scopes)",
          "subtitle": "Biogenic CO2 Emissions",
          "directEmissions": "Direct CO2 emissions from biogenic sources",
          "unit": "tCO2",
          "protocolNote": "Biogenic emissions are reported separately and not included in scope totals per GHG Protocol standards."
        },
        "tableHeaders": {
          "scope": "Scope",
          "totalCO2e": "Total CO2e (tCO2e)",
          "co2": "CO2 (tCO2e)",
          "ch4": "CH4 (tCO2e)",
          "n2o": "N2O (tCO2e)",
          "hfcs": "HFCs (tCO2e)",
          "pfcs": "PFCs (tCO2e)",
          "sf6": "SF6 (tCO2e)"
        }
      },
      "ghgManagementReduction": {
        "title": "GHG Management & Reduction",
        "sectionCompletion": "Section completion",
        "managementPrograms": {
          "title": "GHG Management Programs",
          "actionRequired": "Action Required",
          "programsTitle": "Management Programs & Procedures",
          "description": "Describe operational procedures, monitoring systems, governance frameworks, and compliance programs",
          "placeholder": "Describe your GHG management programs and procedures...",
          "aiAssist": "AI Assist",
          "skipSection": "Skip this section",
          "sectionSkipped": "This section has been skipped",
          "examplesTitle": "Examples to include:",
          "examples": {
            "monitoring": "Continuous emission monitoring, data collection procedures",
            "governance": "Climate committee structure, reporting protocols, decision-making processes",
            "compliance": "Regulatory compliance programs, internal auditing procedures",
            "training": "Employee awareness programs, capacity building initiatives",
            "technology": "Emission reduction technologies, efficiency improvements",
            "targets": "Science-based targets, reduction goals, timeline commitments"
          },
          "exampleLabels": {
            "monitoring": "Monitoring Systems:",
            "governance": "Governance:",
            "compliance": "Compliance:",
            "training": "Training:",
            "technology": "Technology:",
            "targets": "Targets:"
          }
        },
        "managementFramework": {
          "title": "GHG Management Framework",
          "monitoring": {
            "title": "Monitoring",
            "description": "Data collection & tracking"
          },
          "governance": {
            "title": "Governance",
            "description": "Oversight & accountability"
          },
          "compliance": {
            "title": "Compliance",
            "description": "Regulatory adherence"
          },
          "reduction": {
            "title": "Reduction",
            "description": "Target achievement"
          }
        },
        "bestPractices": {
          "title": "GHG Management Best Practices",
          "keyElements": {
            "title": "Key Management Elements",
            "establishRoles": "Establish clear roles and responsibilities",
            "implementMonitoring": "Implement regular monitoring and reporting",
            "setScienceTargets": "Set science-based reduction targets",
            "engageSuppliers": "Engage suppliers and value chain partners"
          },
          "reductionStrategies": {
            "title": "Reduction Strategies",
            "energyEfficiency": "Energy efficiency improvements",
            "renewableEnergy": "Renewable energy adoption",
            "processOptimization": "Process optimization and innovation",
            "supplyChainEngagement": "Supply chain engagement"
          }
        }
      },
      "methodologiesOrganization": {
        "title": "Methodologies & Organizational Structure",
        "sectionCompletion": "Section completion",
        "calculationMethods": {
          "title": "Calculation Methods and Tools",
          "actionRequired": "Action Required",
          "methodsTitle": "Calculation Methods and Tools",
          "description": "Describe methodologies, emission factors, and calculation tools used",
          "placeholder": "Describe the methodologies, emission factors, and calculation tools used in preparing this inventory (e.g., GHG Protocol standards, specific databases like EPA eGRID, calculation software used)...",
          "aiAssist": "AI Assist",
          "skipSection": "Skip this section",
          "sectionSkipped": "This section has been skipped",
          "examples": "GHG Protocol Corporate Standard, EPA Emission Factors, DEFRA conversion factors, proprietary calculation tools, third-party software platforms",
          "examplesLabel": "Examples:"
        },
        "organizationalStructure": {
          "title": "Organizational Structure",
          "description": "This section shows the entities/facilities included in your organizational boundary based on your consolidation approach.",
          "noEntitiesMessage": "No entities/facilities available",
          "noEntitiesHelper": "Entity data will be populated from your organizational setup",
          "tableHeaders": {
            "entityFacilityName": "Entity/Facility Name",
            "location": "Location",
            "type": "Type",
            "scopesIncluded": "Scopes Included",
            "notSpecified": "Not specified"
          }
        },
        "consolidationSummary": {
          "title": "Consolidation Summary",
          "totalEntities": "Total Entities",
          "entitiesUnit": "Facilities/Entities",
          "consolidationApproach": "Consolidation Approach",
          "selectedMethod": "Selected Method",
          "coverage": "Coverage",
          "includeScope3": "Include Scope 3",
          "approaches": {
            "equityShare": "Equity Share",
            "financialControl": "Financial Control",
            "operationalControl": "Operational Control",
            "notSpecified": "Not specified"
          }
        }
      },
      "offsetsAdditionalDisclosures": {
        "title": "Offsets & Additional Disclosures",
        "sectionCompletion": "Section completion",
        "additionalDisclosures": {
          "title": "Additional Disclosures",
          "actionRequired": "Action Required"
        },
        "contractualProvisions": {
          "title": "Contractual GHG Provisions",
          "description": "Contractual agreements related to GHG emissions and risk-sharing provisions",
          "placeholder": "Describe any contractual agreements related to GHG emissions, such as risk-sharing provisions, emission caps, or contractual allocation of emissions responsibilities...",
          "aiAssist": "AI Assist",
          "skipSection": "Skip this section",
          "sectionSkipped": "This section has been skipped",
          "examplesLabel": "Examples:",
          "examples": "Joint venture emission allocation agreements, supplier emission requirements, customer emission caps, shared responsibility clauses"
        },
        "qualityAssurance": {
          "title": "Quality Assurance & Inventory Improvements",
          "description": "Quality assurance procedures and plans for future inventory improvements",
          "placeholder": "Describe quality assurance procedures implemented to ensure accuracy of GHG inventory and plans for future improvements...",
          "aiAssist": "AI Assist",
          "skipSection": "Skip this section",
          "sectionSkipped": "This section has been skipped",
          "examplesLabel": "Examples:",
          "examples": "Data verification procedures, third-party audits, methodology improvements, enhanced monitoring systems, staff training programs"
        },
        "sequestration": {
          "title": "GHG Sequestration Activities",
          "description": "Carbon sequestration and removal activities owned or controlled by your organization",
          "placeholder": "Describe GHG sequestration activities, including reforestation, soil carbon projects, direct air capture, or other carbon removal initiatives...",
          "aiAssist": "AI Assist",
          "skipSection": "Skip this section",
          "sectionSkipped": "This section has been skipped",
          "examplesLabel": "Examples:",
          "examples": "Forest restoration projects, regenerative agriculture, biochar applications, direct air capture technologies, enhanced weathering, carbon capture and storage"
        }
      },
      "reportingScopeBoundaries": {
        "title": "Reporting Scope & Boundaries",
        "sectionCompletion": "Section completion",
        "reportingPeriod": {
          "title": "Reporting Period",
          "startDate": "Start Date",
          "endDate": "End Date",
          "prefilled": "(Prefilled)",
          "infoNote": "The reporting period is typically one calendar year (January 1 - December 31)."
        },
        "organizationalBoundaries": {
          "title": "Organizational Boundaries",
          "consolidationApproach": "Consolidation Approach",
          "equityShare": {
            "title": "Equity Share",
            "description": "Report a share of emissions corresponding to the company's share of equity in the operation."
          },
          "financialControl": {
            "title": "Financial Control",
            "description": "Report 100% of emissions from operations over which the company has financial control."
          },
          "operationalControl": {
            "title": "Operational Control",
            "description": "Report 100% of emissions from operations over which the company has operational control."
          },
          "consistencyNote": "The consolidation approach should be consistent with your financial reporting approach and applied consistently across all reporting periods."
        }
      },
      "preview": {
        "title": "GHG Report Preview",
        "notAvailable": "N/A",
        "reportHeader": {
          "title": "Greenhouse Gas Emissions Report",
          "reportingYear": "Reporting Year",
          "reportLanguage": "Report Language",
          "reportingPeriod": "Reporting Period"
        },
        "verification": {
          "status": "Verification Status"
        },
        "emissions": {
          "totalByScope": "Total Emissions by Scope",
          "detailedByGasType": "Detailed Emissions by Gas Type"
        },
        "units": {
          "tco2e": "tCO2e",
          "tco2": "tCO2"
        },
        "biogenic": {
          "note": "Note: Biogenic emissions are reported separately and not included in scope totals per GHG Protocol standards."
        },
        "baseYear": {
          "year": "Base Year"
        },
        "footer": {
          "generatedOn": "This report was generated on"
        }
      }
    }
  },
  "target": {
    "title": "Targets"
  },
  "transportation": {
    "hgvType": "HGV Type",
    "vanType": "Van Type",
    "ladenPercentage": "Laden Percentage",
    "Unknown":"Unknown",
    "Rigid (>3.5 - 7.5 tonnes)":"Rigid (>3.5 - 7.5 tonnes)",
    "Rigid (>7.5 tonnes-17 tonnes)":"Rigid (>7.5 tonnes-17 tonnes)",
    "Rigid (>17 tonnes)":"Rigid (>17 tonnes)",
    "All rigids":"All rigids",
    "Articulated (>3.5 - 33t)":"Articulated (>3.5 - 33t)",
    "Articulated (>33t)":"Articulated (>33t)",
    "All artics":"All artics",
    "All HGVs":"All HGVs",
    "Class I (up to 1.305 tonnes)":"Class I (up to 1.305 tonnes)",
    "Class II (1.305 to 1.74 tonnes)":"Class II (1.305 to 1.74 tonnes)",
    "Class III (1.74 to 3.5 tonnes)":"Class III (1.74 to 3.5 tonnes)"
  },
  "survey": {
    "autoFilledTooltip": "This field will be filled automatically by the system. You don't need to enter any information.",
    "q1": "Do you do carbon accounting in your company?",
    "q2": "Do you account for Scope 1 emissions?",
    "q3": "Do you account for Scope 2 emissions?",
    "q4": "Have you mapped Scope 3 emissions?",
    "q5": "Do you account for Scope 3 emissions?",
    "q6": "Do you assure your Scope 1 and 2 emissions?",
    "q7": "Do you assure your Scope 3 emissions?",
    "q8": "Do you curently have a renewable energy target?",
    "q9": "Are you part of an initiative such as RE100?",
    "q10": "What % of your purchased electricity is renewable?  ",
    "q11": "Are you advancing on renewable heat?",
    "q12": "What percentage of your heat is renewable?",
    "q13": "Do you report Scope 1 and 2 emissions and progress on an annual basis publicly?",
    "q14": "Do you currently report on CDP?",
    "q15": "Are you currently engaging on suppliers to report on CDP?",
    "q16": "Do you report Scope 3 emissions and progress on an annual basis publicly?",
    "q17": "What is your last year CDP Score?",
    "q18": "Do you currently have a climate associated target?",
    "q19": "Is your target aligned or approved by the Science-Based Target initiative?",
    "q20": "If you don't have a target, do you have plans to set a target in the next year?",
    "q21": "Do you publicly report on progress towards your target?",
    "q22": "Have you mapped your YOY plans towards reaching your goal?",
    "q23": "Have you identified climate-related risks and opportunities?",
    "q24": "Are you following a framework such as TCFD?",
    "q25": "Is climate embedded in the strategy of your business?",
    "q26": "Have you set a net zero ambition?",
    "q27": "If so, what is the target year?",
    "q28": "If not, do you plan on setting an ambition in the next 2 years?",
    "q29": "Have you developed a clear decarbonization pathway towards net zero?",
    "q30": "Are you currently using heat in your operation?",
    "q31": "Will your company be required to report according to CSRD from 2025 ?",
    "categories": {
      "CARBON_ACCOUNTING": "Carbon Accounting",
      "RENEWABLES": "Renewables",
      "REPORTING": "Reporting",
      "TARGET_SETTING": "Target Setting",
      "CLIMATE_STRATEGY": "Climate Strategy",
      "NET_ZERO_READINESS": "Net Zero Readiness"
    },
    "yourAnswer": "Your answer",
    "comment": "Comment (optional)",
    "errorMsg": "Fields marked with * are mandatory.",
    "thankYou": "Thank you for participating in our survey."
  },
  "companyInformation": {
    "companyInfo": "Company’s information"
  },
  "decarbonization": {
    "addToRoadMap": "Add to Road Map",
    "selectFacility": "!Please select facility first",
    "allCompany": "All company",
    "addMyOwnSolution": "Add my own solution",
    "totalFootprint": "Total Base Year Emission",
    "Average": "$ Cost per tCO2 Reduced",
    "roadMapCost": "Roadmap Cost",
    "projectCost": "Project Cost",
    "totalNeeded": "Total needed",
    "totalCo2Reduced": "Emission Reduction",
    "learnMoreInOutBlog": "Learn more in out Blog",
    "marketPlaceRedirectButton": "Get questions from the best vendors in your area",
    "selectedEmissionGroup": "Selected emission group",
    "components": {
      "solutions": "Solutions",
      "road-map": "Road maps",
      "goals": "Goals"
    },
    "form": {
      "projectName": "Project name",
      "spanMonth": "Project span months",
      "cost": "Cost",
      "emissionReductionPercentage": "Emission reduction percentage",
      "emissionGroup": "Select Emission Group",
      "emissionSourceList": "Emission Sources"
    },
    "infoMsg": {
      "title": "We are sorry.",
      "description": "There is not yet an active solution in the selected emission group. You can add your own solution or select a different emission group."
    },
    "costEstimationMessage":"This is an estimated cost, it may change when quoted"
  },
  "goal": {
    "form": {
      "title": "Add target",
      "saveTarget": "Save target",
      "targetName": "Target name",
      "targetType": "Target type",
      "targetScopes": "Target scopes",
      "emissionGroup": "Emission group",
      "baseYear": "Base year",
      "targetYear": "Target year",
      "SCIENCE_BASED": "Science Based",
      "INITIATIVES": "Initiatives",
      "CUSTOM": "Custom",
      "successMsg": "Added goal. Goal created successfully",
      "reductionPercentage": "Reduction",
      "validation": {
        "targetName": "Target name is a required field.",
        "baseYear": "Base year is required",
        "targetYear": "Target year is required",
        "reductionPercentage": "Reduction percentage is required",
        "emissionGroup": "Please select emission group",
        "targetScopes": "You must select at least one target scope"
      }
    },
    "title": "Targets",
    "newTarget": "New target",
    "deleteAlert": "The record will be deleted Are you sure?",
    "legends": {
      "baseline": "Baseline",
      "baselineDescription": "",
      "businessAsUsual": "Business as usual",
      "businessAsUsualDescription": "If you continue doing what you have been doing",
      "targetsWithInitiatives": "Targets with Initiatives",
      "targetsWithInitiativesDescription": "Where can you get by addressing those processes",
      "sbtiTargets": "SBTI Targets",
      "sbtiTargetsDescription": "Where the company expects to be",
      "historicEmissions": "Historic Emissions",
      "historicEmissionsDescription": "First ever carbon footprint calculation",
      "selectedTargets": "Selected targets",
      "targetSelected": "target selected"
    },
    "table": {
      "targetName": "Target name",
      "scope": "Scope",
      "emissions": "Emissions",
      "targetYear": "Target year",
      "reduction": "Reduction"
    },
    "emissionTable": {
      "emissionGroup": "Emission Group"
    }
  },
  "terms": {
    "title": "Terms and conditions",
    "explanation": "You must agree to the following agreements in order to proceed.",
    "errorMsg": "Please accept all fields."
  },
  "messages": {
    "addedEmission": "Emission added successfully",
    "addedEmissionError": "Error adding emission",
    "noDateError": "Please select a date"
  },
  "farmAnimals": {
    "wet": "Wet",
    "dry": "Dry",
    "aeration": "Aeration",
    "solidStorage": "Solid Storage",
    "solidStorageDesc": "The storage of manure, typically for a period of several months, in unconfined piles or stacks. Manure is able to be stacked due to the presence of a sufficient amount of bedding material or loss of moisture by evaporation.",
    "dryLot": "Dry Lot",
    "dryLotDesc": "A paved or unpaved open confinement area without any significant vegetative cover where accumulating manure may be removed periodically. Dry lots are most typically found in dry climates but also are used in humid climates.",
    "liquidSlurry": "Liquid/Slurry (With Natural Crust Cover)",
    "liquidSlurryDesc": "Manure is stored as excreted or with some minimal addition of water to facilitate handling and is stored in either tanks or earthen ponds.",
    "uncoveredAnaerobicLagoon": "Uncovered Anaerobic Lagoon",
    "uncoveredAnaerobicLagoonDesc": "Anaerobic lagoons are designed and operated to combine waste stabilization and storage. Lagoon supernatant is usually used to remove manure from the associated confinement facilities to the lagoon. Anaerobic lagoons are designed with varying lengths of storage (up to a year or greater), depending on the climate region, the volatile solids loading rate, and other operational factors. The water from the lagoon may be recycled as flush water or used to irrigate and fertilize fields.",
    "pitStorageBelowConfinements": "Pit Storage Below Confinements",
    "pitStorageBelowConfinementsDesc": "Collection and storage of manure usually with little or no added water typically below a slatted floor in an enclosed animal confinement facility.",
    "anaerobicDigester": "Anaerobic Digester",
    "anaerobicDigesterDesc": "Anaerobic digesters are designed and operated for waste stabilization by the microbial reduction of complex organic compounds to CH4 and CO2, which is captured and flared or used as a fuel.",
    "compostingInVessel": "Composting - In-Vessel",
    "compostingInVesselDesc": "Composting, typically in an enclosed channel, with forced aeration and continuous mixing.",
    "compostingStaticPile": "Composting - Static Pile",
    "compostingStaticPileDesc": "Composting in piles with forced aeration but no mixing.",
    "aerobicTreatmentNatural": "Aerobic Treatment (Natural Aeration Systems)",
    "aerobicTreatmentNaturalDesc": "The biological oxidation of manure collected as a liquid with either forced or natural aeration. Natural aeration is limited to aerobic and facultative ponds and wetland systems and is due primarily to photosynthesis. Hence, these systems typically become anoxic during periods without sunlight.",
    "aerobicTreatmentForced": "Aerobic Treatment (Forced Aeration Systems)",
    "aerobicTreatmentForcedDesc": "Aerobic treatment using forced aeration systems.",
    "poultryManure": "Poultry Manure",
    "poultryManureDesc": "Similar to deep bedding systems. Typically used for all poultry breeder flocks and for the production of meat-type chickens (broilers) and other fowl."

  },
  "Collaborators": "Collaborators",
  "addCollaborators": "Add Collaborators",
  "userInfo": {
    "userInformation": "User Information",
    "name": "Name",
    "lastName": "Last Name",
    "password": "Password",
    "passwordUpdate": "To update",
    "position": "Position within the company",
    "passwordUpdateModalTitle": "Update Password"
  },
  "facilityFilters": {
    "search": "Search facility",
    "facilityName": "Facility Name",
    "facilityType": "Facility Type",
    "tags": "Tags",
    "countries": "Countries",
    "calculationStatus": "Calculation Status",
    "showAll": "Show all",
    "completed": "Completed",
    "pending": "Pending",
    "apply": "Apply",
    "save": "Save",
    "clear": "Clear",
    "activeFilters": "There are active filters",
    "NO_DATA": "No facility found. Change your filter criteria."
  },
  "ANALYSIS_FILTER_BAR_COMPONENT": {
    "BREAKDOWNS": "Breakdowns",
    "GROUPS": "Groups"
  },
  "MONTH_1": "January",
  "MONTH_2": "February",
  "MONTH_3": "March",
  "MONTH_4": "April",
  "MONTH_5": "May",
  "MONTH_6": "June",
  "MONTH_7": "July",
  "MONTH_8": "August",
  "MONTH_9": "September",
  "MONTH_10": "October",
  "MONTH_11": "November",
  "MONTH_12": "December",
  "UNNAMED_FACILITY": "Unnamed facility",
  "DELETED_FACILITY_TO_BE_REMOVED": "Delete the facility to be removed.",
  "bulkUploads": {
    "status":{
      "UPLOADED": "Uploaded",
      "VALIDATING": "Validating",
      "VALIDATION_INPUT_REQUIRED": "Validation Input Required",
      "VALIDATED": "Validated",
      "CORRECTING": "Correcting",
      "PROCESSING": "Processing",
      "PROCESSED": "Processed",
      "PROCESSED_WITH_ERRORS": "Processed with Errors",
      "ERROR": "ERROR"
    },
    "lineStatus":{
      "VALID":"Valid",
      "NEEDS_CORRECTION": "Needs Correction",
      "PROCESSED": "Processed",
      "NOT_PROCESSED": "Not Processed"
    }
  },
  "SUBMIT_SUCCESS_MESSAGE": "Form successfully submitted.",
  "CARBON_ACCOUNTING_USER": "Facility Responsible",
  "CARBON_ACCOUNTING_ADMIN": "Admin",
  "CARBON_ACCOUNTING_READ_ONLY": "Read only",
  "EXTERNAL_IDP_USER_CREATE_WARNING_MSG_TITLE": "You can't perform this action here.",
  "EXTERNAL_IDP_USER_CREATE_WARNING_MSG_EXPLANATION": "Your login method (e.g., company account) is managed by an external identity system.\nTo add a new user, please contact your company's IT team.",
  "dataReport": {
    "reportView": "Report View",
    "table": "Table",
    "chart": "Chart",
    "insight": "Insight",
    "selectChartType": "Select chart type",
    "editQuery": "Edit Query",
    "updateReport": "Update Report",
    "backToReport": "Back to Report",
    "hideQueryBuilder": "Hide query builder",
    "reportSavedSuccessfully": "Report saved successfully!",
    "failedToSaveReport": "Failed to save report",
    "failedToRunQuery": "Failed to run query"
  },
  "dataExplorer": {
    "title": "Data Explorer",
    "subtitle": "Build and analyze queries with visual drag-and-drop interface",
    "saveQuery": "Save Query",
    "saveReport": "Save Report",
    "savedQueries": "Saved Queries",
    "showQueryBuilder": "Show Query Builder",
    "hideQueryBuilder": "Hide Query Builder",
    "getStarted": "Get Started with Data Exploration",
    "emptyStateDescription": "Select an entity from the dropdown above to start building queries, exploring data, and creating visualizations.",
    "chooseEntity": "Choose an entity to begin",
    "showingResults": "Showing {count} results",
    "table": "Table",
    "chart": "Chart",
    "selectChartType": "Select chart type",
    "noEntitySelected": "No entity selected",
    "pleaseSelectEntity": "Please select an entity first",
    "aiQuerySuccess": "AI query generated and executed successfully!",
    "aiQueryWarning": "AI query generated but execution failed. Please review and run manually.",
    "aiQueryFailed": "AI Query Failed",
    "aiQueryFailedDetail": "Failed to generate query from prompt. Please try again or provide more specific details.",
    "queryConfigNotFound": "Query configuration not found",
    "queryLoaded": "Query \"{queryName}\" loaded into Query Builder!",
    "failedToLoadQuery": "Failed to load saved query",
    "noQueryToSaveReport": "No query to save. Please run a query first.",
    "noQueryToSaveQuery": "No query to save. Please run a query first.",
    "reportSavedSuccessfully": "Report saved successfully!",
    "failedToSaveReport": "Failed to save report",
    "querySavedSuccessfully": "Query saved successfully!",
    "failedToSaveQuery": "Failed to save query"
  },
  "insightCard": {
    "title": "AI Data Insights",
    "poweredBy": "Powered by Bono artificial intelligence",
    "aiGenerated": "AI Generated",
    "keyFindings": "Key Findings",
    "regenerate": "Regenerate",
    "analyzingData": "AI is analyzing your data",
    "generatingInsights": "Generating intelligent insights..."
  },
  "activityLog": {
    "title": "Activity Log",
    "subtitle": "Monitor and track all activities in your organization",
    "activityFeed": "Activity Feed",
    "summary": "Summary",
    "detailed": "Detailed",
    "noEvents": "No activity events found",
    "loading": "Loading activity events...",
    "loadMore": "Load more",
    "filters": {
      "dateRange": "Date Range",
      "domain": "Domain",
      "visibilityLevel": "Visibility Level",
      "search": "Search"
    }
  },
  "BULK_UPLOAD": {
    "configurator": {
      "title": "Configure Bulk Upload",
      "description": "Add multiple emission source configurations to generate a comprehensive CSV template",
      "emissionGroup": "Emission Group",
      "emissionSource": "Emission Source",
      "unit": "Unit",
      "period": "Period",
      "facilities": "Facilities",
      "addToList": "Add to List",
      "clear": "Clear",
      "addedConfigurations": "Added Configurations ({count})",
      "rows": "Rows",
      "actions": "Actions",
      "facilityCount": "{count} facility | {count} facilities",
      "totalSummary": "Total: {rows} rows across {configurations} configurations will be generated",
      "emptyState": "No configurations added yet",
      "emptyStateHint": "Fill the form above and click 'Add to List' to start building your CSV template",
      "remove": "Remove",
      "generateCSV": "Generate & Download CSV",
      "generateExcel": "Generate & Download Excel",
      "downloadSuccess": "Excel file generated successfully",
      "downloadError": "Failed to generate Excel file. Please try again.",
      "cancel": "Cancel",
      "fileName": "carbon_footprint_bulk_upload",
      "periodTypes": {
        "ANNUAL": "Annual (1x)",
        "MONTHLY": "Monthly (12x)",
        "CUSTOM": "Custom (1x)"
      },
      "selectPlaceholder": "Select",
      "required": "Required",
      "hgvType": "HGV Type",
      "vanType": "Van Type",
      "liveStockType": "Animal Type",
      "temperatureType": "Average Temperature (°C)",
      "manureManagement": "Manure Management"
    },
    "hgvTypes": {
      "unknown": "Unknown",
      "rigid_3_5_7_5": "Rigid (>3.5 - 7.5 tonnes)",
      "rigid_7_5_17": "Rigid (>7.5 tonnes-17 tonnes)",
      "rigid_17_plus": "Rigid (>17 tonnes)",
      "all_rigids": "All rigids",
      "articulated_3_5_33": "Articulated (>3.5 - 33t)",
      "articulated_33_plus": "Articulated (>33t)",
      "all_artics": "All artics",
      "all_hgvs": "All HGVs"
    },
    "vanTypes": {
      "unknown": "Unknown",
      "class_1": "Class I (up to 1.305 tonnes)",
      "class_2": "Class II (1.305 to 1.74 tonnes)",
      "class_3": "Class III (1.74 to 3.5 tonnes)"
    },
    "livestockTypes": {
      "Alpacas": "Alpacas",
      "Buffalo": "Buffalo",
      "Camels": "Camels",
      "Cattle": "Cattle",
      "Chicken": "Chicken",
      "Deer": "Deer",
      "Goats": "Goats",
      "Horses": "Horses",
      "Pigs": "Pigs",
      "Sheep": "Sheep"
    },
    "fieldComments": {
      "activityData": "Enter the weight of the cargo in tonnes",
      "activityDataPassengers": "Enter the number of passengers",
      "distance": "Enter in kilometers",
      "fromName": "Enter origin name",
      "toName": "Enter destination name",
      "ladenPercentage": "Enter load percentage without % sign"
    },
    "fileUpload": {
      "configuratorHeader": "Configure Bulk Upload",
      "referenceGuideTitle": "CSV Template Reference Guide",
      "importantNotice": "Your Excel Template Is Ready!",
      "referenceGuideDescription": "The template includes pre-configured sheets, dropdown options, and helpful comments. Check the comments in the header row for tips on what to enter in each field. In the Appendix tab, you'll find example rows and a list of valid field options. When you're done, fill in your activity data and upload the file. Need a quick overview? See the cards below for what data to enter.",
      "configureDownload": "Configure & Download Template",
      "downloadCSV": "Download CSV",
      "searchPlaceholder": "Search fields by name, description, or type...",
      "searchResults": "{count} field found | {count} fields found",
      "noFieldsFound": "No fields found",
      "tryDifferentKeywords": "Try searching with different keywords",
      "description": "Description",
      "type": "Type",
      "validValues": "Valid Values",
      "required": "Required",
      "optional": "Optional",
      "fieldTypes": {
        "number": "Number (decimal)",
        "text": "Text",
        "integer": "Whole number",
        "selection": "Selection from list",
        "yesNo": "Yes/No",
        "date": "Date",
        "dateTime": "Date & Time"
      },
      "uploadGuide": "Upload Guide",
      "uploadFile": "Upload File",
      "noUploadHistory": "No upload history yet",
      "getStarted": "Get started by configuring and downloading your Excel template",
      "configureTemplate": "Configure & Download Template",
      "fileName": "File Name",
      "uploadDate": "Upload Date",
      "status": "Status",
      "createdBy": "Created By",
      "actions": "Actions",
      "expand": "Expand",
      "collapse": "Collapse",
      "lineNumber": "Line #",
      "sendCorrections": "Send Corrections",
      "processWithErrors": "Process with Errors",
      "cancel": "Cancel",
      "startUpload": "Start upload",
      "selectFile": "Select File",
      "correctData": "Correct the Data",
      "viewRows": "View Rows",
      "close": "Close",
      "toasts": {
        "selectFileWarning": "Please select a file before uploading.",
        "uploadSuccess": "File uploaded successfully!",
        "uploadError": "Failed to upload file.",
        "correctAllLines": "Correct All Lines",
        "notAllCorrected": "Not all error fields are corrected. Please correct all fields before submitting.",
        "correctionsSuccess": "Corrections submitted successfully!",
        "correctionsError": "An error occurred while submitting corrections.",
        "success": "Success",
        "error": "Error",
        "warning": "Warning",
        "uploadFailed": "Upload Failed"
      }
    }
  }
}
